import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import { useIssue } from "components/modules/Issues/lib/hooks/useProjectIssues";
import { UrlObject } from "url";

export default function BreadcrumbIssue(p: {
  params: string[];
  href: UrlObject;
}) {
  const { issue } = useIssue(p.params[0]);
  return (
    <BreadcrumbLink href={p.href}>
      {issue?.idFriendly || "Loading..."}
    </BreadcrumbLink>
  );
}
